import {Component, OnInit} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../shared/shared.service';
import {MatDialog} from '@angular/material';
import {LoggerService} from '../../logger/logger.service';
import {LocalStorageService} from 'angular-2-local-storage';
import {AgentService} from '../agent.service';
import {UsagePaymentsService} from '../../payment/usage-payments/usage-payments.service';
import {DatePipe} from '@angular/common';
import * as FileSaver from 'file-saver';

@Component({
	selector: 'app-sup-download',
	templateUrl: './sup-download.component.html',
	styleUrls: ['./sup-download.component.css']
})
export class SupDownloadComponent implements OnInit {
	search_key: any;
	is_validate: any;
	public isButtonDisabled: boolean = false;
	private screen: string = 'ban_search';
	billingAccountNumberFormControl = new FormControl('', [
		Validators.required,
	]);

	constructor(private activatedRoute: ActivatedRoute,
				private sharedService: SharedService, private dialog: MatDialog, private logger: LoggerService, private router: Router,
				private localStorageService: LocalStorageService, private agentService: AgentService, private usagePaymentsService: UsagePaymentsService) {
		this.sharedService.setHeaderTitle(this.screen);
		this.sharedService.IsTheSessionValid(this.screen, true);
		this.search_key = '';
	}

	ngOnInit() {
	}

	validate(event: any) {
		if (this.search_key !== '') {
			this.is_validate = true;
			if (event.keyCode === 13) {
				document.getElementById('btn-click').click();
			}
		} else {
			this.is_validate = false;
		}
	}

	searchAccount() {
		this.isButtonDisabled = true;
		this.sharedService.setLoader(this.screen, true);
		this.sharedService.setHeaderErrorMessage(this.screen, false, 'notification error', '');
		this.sharedService.setHeaderSuccessMessage(this.screen, false, '');

		this.usagePaymentsService.getSUPPdf(this.search_key, true).then((res) => {
				this.sharedService.setLoader(this.screen, false);
				this.isButtonDisabled = false;

			if (res.ok) {
				this.sharedService.setLoader(this.screen, false);
				this.isButtonDisabled = false;
				const blob = res.blob();
				if (blob != null) {
					const monthYear = new DatePipe('en-US').transform(new Date(), 'MMMM yyyy');
					const filename = 'PogoEnergyUsageAndPaymentStatement_' + this.search_key.toString() + '_' + monthYear + '.pdf';
					FileSaver.saveAs(blob, filename);
				} else {
					this.sharedService.setHeaderErrorMessage(this.screen, true, 'notification error', res.message);
					this.sharedService.setLoader(this.screen, false);
				}
			}
			}).catch((error) => {
				console.error(error)
				this.sharedService.setLoader(this.screen, false);
				this.isButtonDisabled = false;
				this.sharedService.setHeaderErrorMessage(this.screen, true, 'notification error',
				'There was an issue obtaining your report, please try again.');
			});

	}
}



// WEBPACK FOOTER //
// ./src/app/agent/sup-download/sup-download.component.ts